import React, {ReactNode, useState} from 'react'
import {useOnEvent} from 'react-app-events'
import CheckoutVersionContext from '@providers/CheckoutVersionContext'

import CheckoutErrorProvider from '../providers/CheckoutErrorProvider'

import CheckoutOptionsContext, {CheckoutOptionsContextValue} from './CheckoutOptionsContext'
import FullyBlocked from './FullyBlocked'
import ModalContext from './ModalContext'
import OptimisticCheckoutContext from './OptimisticCheckoutContext'

const CheckoutV3ContextProvider = ({
  children,
  options = {}
}: {
  children: ReactNode
  options?: CheckoutOptionsContextValue
}) => {
  const [isLocked, setIsLocked] = useState(false)
  const [isFullyBlocked, setIsFullyBlocked] = useState(false)
  const [modal, setModal] = useState<string | undefined>()
  const [modalPassedData, setModalPassedData] = useState<any>()
  const [redirectUrl, setRedirectUrl] = React.useState<string | null>(null)

  useOnEvent('setPaymentRedirectUrl', url => {
    setTimeout(() => {
      setRedirectUrl(url)
    }, 3000)
  })

  return (
    <CheckoutVersionContext.Provider value="v3">
      <CheckoutOptionsContext.Provider value={options}>
        <OptimisticCheckoutContext.Provider
          value={{
            isLocked: isLocked,
            optimisticStart: () => setIsLocked(true),
            optimisticEnd: () => setIsLocked(false),
            isFullyBlocked: isFullyBlocked,
            fullyBlockedStart: () => setIsFullyBlocked(true),
            fullyBlockedEnd: () => setIsFullyBlocked(false)
          }}>
          <ModalContext.Provider
            value={{
              openModal: (modalToOpen: string, passedData: any) => {
                setModal(modalToOpen)
                setModalPassedData(passedData)
              },
              closeModal: (modalToClose: string) => {
                if (modalToClose !== modal) return
                setModal(undefined)
                setModalPassedData(undefined)
              },
              modalData: modalPassedData,
              modal
            }}>
            {isFullyBlocked ? <FullyBlocked redirectUrl={redirectUrl} /> : null}
            <CheckoutErrorProvider>{children}</CheckoutErrorProvider>
          </ModalContext.Provider>
        </OptimisticCheckoutContext.Provider>
      </CheckoutOptionsContext.Provider>
    </CheckoutVersionContext.Provider>
  )
}

export default CheckoutV3ContextProvider
